import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { UsuarioProvider } from './context/UsuarioContext';
import { ToastProvider } from './components/ui/ToastContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UsuarioProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </UsuarioProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
